export default 'M7.27 2h13.48l-.52 3H14.7l-2.34 14h5.4l-.52 3H3.75l.52-3H9.3l2.34-14h-4.9z';